var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThickCircleOverlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 122,
    viewBox: "0 0 167 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.48 -13.4487C166.48 60.8268 99.5319 121.039 16.9467 121.039C-65.6384 121.039 -132.587 60.8268 -132.587 -13.4487C-132.587 -87.7243 -65.6384 -147.937 16.9467 -147.937C99.5319 -147.937 166.48 -87.7243 166.48 -13.4487ZM-126.606 -13.4487C-126.606 57.8558 -62.335 115.66 16.9467 115.66C96.2285 115.66 160.499 57.8558 160.499 -13.4487C160.499 -84.7533 96.2285 -142.557 16.9467 -142.557C-62.335 -142.557 -126.606 -84.7533 -126.606 -13.4487Z",
    fill: "white",
    fillOpacity: 0.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickCircleOverlay);
export default __webpack_public_path__ + "static/media/thick_circle_overlay.41b4b7660b63c005a68b8ca6b3284bb1.svg";
export { ForwardRef as ReactComponent };